export function removeItem(arr, item) {
  const index = arr.indexOf(item);
  if (index !== -1) {
    const result = [...arr];
    result.splice(index, 1);
    return result;
  }
  return arr;
}

export function removeDuplicates(arr, getValue = (v) => v) {
  const seen = {};
  return arr.filter((item) => {
    if (seen[getValue(item)]) {
      return false;
    }
    seen[getValue(item)] = true;
    return true;
  });
}

export const moveToFront = (arr, item) => {
  arr = [...arr];
  const idx = arr.indexOf(item);
  if (idx !== -1) {
    arr.unshift(arr.splice(idx, 1)[0]);
  }
  return arr;
};

export const shuffleArray = (arr) => {
  const newArray = [...arr];
  for (let i = newArray.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = newArray[i];
    newArray[i] = newArray[j];
    newArray[j] = temp;
  }
  return newArray;
};
